import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css'; // Import your CSS file for styling

const el = document.getElementById('root');
const root = ReactDOM.createRoot(el);

root.render(<App />);